module.exports = __webpack_public_path__ + "img/golden-line@3x.47b958ac.png";